<template>
  <v-card outlined>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2">mdi-bell-ring</v-icon>
      Notifications d’appel
      <v-spacer />
      <v-chip small :color="chipColor" text-color="white">
        {{ chipLabel }}
      </v-chip>
    </v-card-title>

    <v-card-text>
      <div class="text--secondary">
        Affiche une alerte système quand un appel arrive (utile si l’onglet est en arrière-plan).
      </div>

      <v-alert
        v-if="permission === 'denied'"
        type="warning"
        dense
        class="mt-3"
      >
        Les notifications sont bloquées. Dans Chrome : cliquez sur le cadenas à gauche de l’URL → Paramètres du site → Notifications.
        Puis sur macOS : Réglages Système → Notifications → Google Chrome.
      </v-alert>

      <v-alert
        v-if="!supported"
        type="error"
        dense
        class="mt-3"
      >
        Notifications non supportées dans ce navigateur.
      </v-alert>
    </v-card-text>

    <v-card-actions>
      <v-btn
        v-if="supported && permission === 'default'"
        color="primary"
        @click="enableNotifications"
      >
        <v-icon left>mdi-bell-plus</v-icon>
        Activer
      </v-btn>

      <v-btn
        v-if="supported && permission === 'granted'"
        text
        @click="sendTestNotification"
      >
        <v-icon left>mdi-bell-check</v-icon>
        Tester
      </v-btn>

      <v-spacer />

      <v-btn text small @click="refreshPermission">
        <v-icon left small>mdi-refresh</v-icon>
        Actualiser
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ACallNotificationsCard",
  data() {
    return {
      supported: false,
      permission: "unsupported", // default | granted | denied | unsupported
    };
  },
  mounted() {
    this.refreshPermission();
  },
  computed: {
    chipLabel() {
      if (!this.supported) return "Non supporté";
      if (this.permission === "granted") return "Activées";
      if (this.permission === "denied") return "Bloquées";
      return "À activer";
    },
    chipColor() {
      if (!this.supported) return "red darken-2";
      if (this.permission === "granted") return "green darken-1";
      if (this.permission === "denied") return "orange darken-2";
      return "blue darken-2";
    },
  },
  methods: {
    refreshPermission() {
      this.supported = typeof window !== "undefined" && "Notification" in window;
      if (!this.supported) {
        this.permission = "unsupported";
        return;
      }
      this.permission = Notification.permission; // default | granted | denied
    },

    async enableNotifications() {
      if (!this.supported) return;

      // IMPORTANT : doit être déclenché par un clic utilisateur (ici OK)
      const perm = await Notification.requestPermission();
      this.permission = perm;

      if (perm === "granted") {
        // test immédiat (macOS/Chrome : très utile)
        this.sendTestNotification();
      }
    },

    sendTestNotification() {
      if (!this.supported) return;
      if (this.permission !== "granted") return;

      try {
        const n = new Notification("✅ Notifications activées", {
          body: "Vous serez alerté lors d’un appel entrant.",
          // icon: "/img/call.png",
          // requireInteraction: true, // optionnel
        });

        n.onclick = () => {
          window.focus();
          n.close();
        };
      } catch (e) {
        // Même avec granted, macOS peut filtrer (Focus / réglages OS)
        // Tu peux afficher un snackbar vuetify ici
        // this.$emit("error", e);
        // ou console
        // eslint-disable-next-line no-console
        console.warn("Notification test failed:", e);
      }
    },
  },
};
</script>
